/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Content_Description_PlaceholderInputs */

const en_content_description_placeholder = /** @type {(inputs: Content_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. A documentary about wildlife in the Amazon rainforest...`)
};

const fr_content_description_placeholder = /** @type {(inputs: Content_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par exemple, un documentaire sur la faune sauvage de la forêt amazonienne...`)
};

const de_content_description_placeholder = /** @type {(inputs: Content_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. eine Dokumentation über die Tierwelt im Amazonas-Regenwald...`)
};

const it_content_description_placeholder = /** @type {(inputs: Content_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ad esempio, un documentario sulla fauna selvatica nella foresta pluviale amazzonica...`)
};

const ru_content_description_placeholder = /** @type {(inputs: Content_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Например, документальный фильм о дикой природе амазонских тропических лесов...`)
};

const es_content_description_placeholder = /** @type {(inputs: Content_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por ejemplo, un documental sobre la vida salvaje en la selva amazónica...`)
};

const zh_cn2_content_description_placeholder = /** @type {(inputs: Content_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如：一部关于亚马逊雨林野生动物的纪录片……`)
};

const ja_content_description_placeholder = /** @type {(inputs: Content_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例：アマゾンの熱帯雨林に生息する野生動物に関するドキュメンタリー…`)
};

const hi_content_description_placeholder = /** @type {(inputs: Content_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उदाहरण के लिए, अमेज़न वर्षावन में वन्यजीवों पर आधारित एक वृत्तचित्र...`)
};

const pt_pt2_content_description_placeholder = /** @type {(inputs: Content_Description_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por exemplo, um documentário sobre a vida selvagem na floresta amazônica...`)
};

/**
* | output |
* | --- |
* | "e.g. A documentary about wildlife in the Amazon rainforest..." |
*
* @param {Content_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const content_description_placeholder = /** @type {((inputs?: Content_Description_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Content_Description_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_content_description_placeholder(inputs)
	if (locale === "de") return de_content_description_placeholder(inputs)
	if (locale === "it") return it_content_description_placeholder(inputs)
	if (locale === "ru") return ru_content_description_placeholder(inputs)
	if (locale === "es") return es_content_description_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_content_description_placeholder(inputs)
	if (locale === "ja") return ja_content_description_placeholder(inputs)
	if (locale === "hi") return hi_content_description_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_content_description_placeholder(inputs)
	return en_content_description_placeholder(inputs)
});